<template>
    <div> 
    <!-- //--------------------------[ACTION SIDE]--------------------- -->
        <!-- CLICK MODE -->  
        <v-col v-if="click_mode && (LocalCashup) " cols="12" sm="12" class="ma-0 py-0 pl-0 pr-0"> 
            <v-card tile class="pb-" outlined v-if="false"> 
                <v-tabs class="not-full-w sales-dash"
                    background-color="secondary"
                    icons-and-text
                    color="primary"
                    slider-color="secondary"
                    height="65" show-arrows
                    grow :vertical="false"
                    > 
                    <v-tab :dark="false" v-for="(item,index) in AllActionItems" class="mr-1 " :class="(index==0?'ml-1 ':'ml-0 ')+(item.color?item.color:' b2')">
                        {{item.name}}
                        <v-icon>{{item.icon}}</v-icon>
                    </v-tab> 
                </v-tabs>
            </v-card>  
            <mbs-click-select-items  
                @click_mode="UPDATE_CLICK_MODE(!click_mode)"
                @update_department="value=>selected_departments=value"
                @item_action="ITEM_ACTION"
                @select_item="value=>value?ADD_ITEM(value.key):''"
                :selected_department_codes="CurrentTill?CurrentTill.selected_department_codes:null"
                :edit_order_items="edit_order_items"
                :allow_changing_department="AllowChangingDepartments"
                :action_items="AllActionItems"/>  
        </v-col>


        <!-- SEARCH MODE --> 
        <v-card v-else flat color="grey lighten-2" :height="vsh-165" class="">  
            <!-- <v-card :height="'100%'" flat color="grey lighten-2" class="mbs-scroll-y-hide ">   -->
            <v-card :height="'100%'" flat outlined class="mbs-scroll-y " color="">  
                <!-- <v-toolbar color="primary"  class='mb-2' height="60" dark flat >
                </v-toolbar> --> 
                <v-autocomplete v-if="MBS.actions.SIZE(ItemDepartments)"
                    flat class="mx-2 mt-1"
                    v-model="selected_departments"
                    :items="ItemDepartments"
                    :disabled="!AllowChangingDepartments"
                    item-text="name"
                    item-value="code" 
                    chips
                    dense :label="MBS.actions.SIZE(selected_departments)?'':'Select Department'" 
                    filled outlined
                    multiple
                    small-chips
                    color="" 
                    >
                    <template v-slot:selection="data">
                        <v-chip :disabled="!AllowChangingDepartments"
                            v-bind="data.attrs"
                            :input-value="data.selected"
                            close color="secondary"
                            @click="data.select" dense small
                            @click:close="REMOVE_DEPARTMENT(data.item)" > 
                            {{ data.item.name }}
                        </v-chip>
                    </template>
                </v-autocomplete> 
                <mbs-actions-field  class="my-1"
                    :disabled_types="ActionTypesDisabled"
                    :items="ActionItems"
                    :waiter_uid="tus?.uid"
                    @ITEM_ACTION="ITEM_ACTION"/>    
            </v-card>
        </v-card>   
    </div>
</template> 
<script> 

    import DATA from "../../../plugins/DATA";
    import {mapState} from "vuex"  
    import { mdiTextBoxSearch } from '@mdi/js';
    import { mdiInvoiceTextPlusOutline } from '@mdi/js';
    import { mdiInvoiceCheckOutline } from '@mdi/js';
    
    const PAGE_NAME = "SALE-ACTIONS-MODES"

    export default {
        props:['height','click_mode'],
        data(){
            return{
                show:false,     
                selected_departments:null, 
                dialog_action_menu:false, 
                mdiTextBoxSearch:mdiTextBoxSearch,
                mdiInvoiceTextPlusOutline:mdiInvoiceTextPlusOutline,
                mdiInvoiceCheckOutline:mdiInvoiceCheckOutline,
                edit_order_items:false, 

            }
        },
        created(){ 
            try { 
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'created',
                    page:PAGE_NAME, 
                }) 
            }
        },
        mounted(){  
            this.INITIALIZE_ITEMS_CATEGORIES()
            this.INITIALIZE_ITEMS_DEPARTMENTS()
        },
        computed:{
            vs(){
                let vs = this.$vuetify.breakpoint 
                return vs
            }, 
            vs_width(){
                let vs = this.vs
                if(!vs){return null}
                return vs.width
            },
            vsh(){
                return this.vs.height
            },
            ...mapState({
                loading:state=>state.load.loading,
                processes:state=>state.load.processes,
                responses:state=>state.load.responses,
            }),
            ...mapState({
                us: state=> state.users[(DATA.ITEMS.USERS.value).toUpperCase()],
                ud: state=> state.users[(DATA.ITEMS.USER_DETAILS.values).toUpperCase()],
                tus: state=> state.users["TEMPORARY_USER"], 
                SELECTED_COMPANY: state=> state.items['SELECTED_COMPANY'],
                K_CONNECTOR: state=> state.items['K_CONNECTOR'],
            }),
            ...mapState({
                CompanySettings: state=> state.items[(DATA.ITEMS.COMPANY_SETTINGS.values).toUpperCase()], 
                CompanyQuickActions: state=> state.items[(DATA.ITEMS.COMPANY_QUICK_ACTIONS.values).toUpperCase()], 
                Items: state=> state.items[(DATA.ITEMS.ITEMS.values).toUpperCase()],
                JoinedItems: state=> state.join[(DATA.ITEMS.ITEMS.values).toUpperCase()], 
                ItemCategories: state=> state.items[(DATA.ITEMS.ITEM_CATEGORIES.values).toUpperCase()],
                ItemDepartments: state=> state.items[(DATA.ITEMS.ITEM_DEPARTMENTS.values).toUpperCase()],
                Tills: state=> state.items[(DATA.ITEMS.TILLS.values).toUpperCase()],
                JoinedTills: state=> state.join[(DATA.ITEMS.TILLS.values).toUpperCase()], 

                LocalCashups: state=> state.locals[(DATA.ITEMS.LOCAL_CASHUPS.values).toUpperCase()],
                
            }), 

            TillsData(){
                return this.JoinedTills?this.JoinedTills:this.Tills
            }, 
            CurrentTill(){
                let tills = this.TillsData
                let cashup = this.LocalCashup  
                if(!tills || !cashup){return null}
                let filled = tills.find(item=>{
                    return item.key == cashup.till_key
                })   
                return filled
            },

            LocalCashup(){    
                let cashups = this.LocalCashups 
                let local_cashup = cashups?cashups.find(item=>{
                    return !item.closed
                }):null 
                this.day_shift_key = local_cashup?.day_shift_key 
                return local_cashup
            }, 
            AllActionItems(){  
                return [ 
                    {
                        icon:"mdi-gesture-tap-hold",
                        action:"click_mode", 
                        name:"Click Mode",
                        color:"green",
                        type:"sales"
                    },{
                        icon:"mdi-refresh",
                        action:"refresh_data", 
                        name:"Refresh",
                        color:"secondary",
                        type:""
                    },
                    { 
                        icon:"remove_shopping_cart",
                        action:"clear_sales", 
                        name:"Clear",
                        color:"red",
                        type:"sales"
                    },{ 
                        icon:"shopping_cart",
                        action:"view_orders", 
                        name:"Order(s)",
                        color:"yellow",
                        type:"sales",
                        menu:{
                            name:"Orders",
                            items:[
                                {icon:"mdi-cart",action:"view_orders",name:"Orders List"}, 
                                {icon:"mdi-cart-heart",action:"view_customers_orders",name:"Customer Orders"},
                                {icon:"mdi-cash-register",action:"view_assistant_till_orders",name:"Assistant Till Orders", show:(this_)=>this_.HasAssistant},
                                {icon:"mdi-table-chair",action:"view_table_orders",name:"Table Orders", show:(this_)=>this_.IsRestaurant},
                                {icon:"mdi-face-agent",action:"view_waiter_orders",name:"Waiter Orders", show:(this_)=>this_.IsRestaurant},
                            ]
                        },
                        indicator:{ 
                            value_text:(this_,field,data)=>{
                                const NewOrders = data?.NewItemOrders?.new_items
                                const size = this_.MBS.actions.SIZE(NewOrders)
                                return size+" New Order(s)"
                            },
                            value:(this_,field,data)=>{
                                const NewOrders = data?.NewItemOrders?.new_items
                                const size = this_.MBS.actions.SIZE(NewOrders)
                                return size>10?"10+":size
                            },
                            show:(this_,field,data)=>{
                                const NewOrders = data?.NewItemOrders?.new_items
                                const size = this_.MBS.actions.SIZE(NewOrders)
                                return size?true:false
                            },
                            color:"green"
                        }
                    },{ 
                        icon:"mdi-archive-arrow-down-outline",
                        action:"open_drawer", 
                        name:"Drawer",
                        color:"blue",
                        type:"sales",
                        show:(this_)=>!this_.Assistant
                    },
                    // { 
                    //     action:"settings", 
                    //     name:"Settings",
                    //     color:"",
                    //     type:"sales"
                    // }, 
                    { 
                        icon:"mdi-clipboard-text-clock",
                        action:"history", 
                        name:"History", 
                        color:"", 
                        type:"sales",
                        show:(this_)=>!this_.Assistant,
                        menu:{
                            name:"Histories",
                            items:[
                                {icon:"mdi-cart-check",action:"history_sales",name:"Sales"},
                                {icon:"mdi-cart-off",action:"history_return_sales",name:"Returned Sales"},
                                {icon:"mdi-cash-check",action:"history_return_sales",name:"Paid Invoices"},
                                {icon:"mdi-text-box-multiple-outline",action:"history_return_sales",name:"Issued Quotations"},
                                // {icon:"mdi-sun-clock",action:"history_cashups",name:"Dayshifts"}, 
                                // {icon:"mdi-cash-clock",action:"history_dayshifts",name:"Cashups"},  
                            ]
                        }
                    }, 
                    { 
                        icon:"content_copy",
                        action:"last_print", 
                        name:"Duplicate", 
                        color:"", 
                        type:"sales",
                        no_fiscal_printer:true,
                        show:(this_)=>!this_.Assistant
                    },  
                    { 
                        icon:"mdi-clipboard-text-clock",
                        action:"receive_payment", 
                        name:"Receive Payment", 
                        color:"", 
                        type:"sales",
                        show:(this_)=>!this_.Assistant
                    }, 
                    { 
                        icon:mdiTextBoxSearch,
                        action:"find_receipt", 
                        name:"Find", 
                        color:"", 
                        type:"sales"
                    },   
                    { 
                        icon:"mdi-cart-off",
                        action:"sales_return", 
                        name:"Sales Return", 
                        color:"", 
                        type:"sales",
                        show:(this_)=>!this_.Assistant
                    },  
                    { 
                        icon:"mdi-file-table-box",
                        action:"add_new_customer", 
                        name:"Inventory", 
                        color:"pink darken-4", 
                        menu:{
                            name:"Manage Inventory",
                            items:[
                                {icon:"mdi-file-table-box-outline",action:"view_inventory",name:"View Inventory"},
                                {icon:mdiInvoiceTextPlusOutline,action:"stock_requisition",name:"Stock Requisition"},
                                {icon:"mdi-transfer",action:"transfer_stock",name:"Transfer Stock"}, 
                                {icon:mdiInvoiceCheckOutline,action:"verify_stock",name:"Verify Stock"}, 
                                {icon:"mdi-contrast-box",action:"stock_control",name:"Stock Control"}, 
                                {icon:"mdi-cog-transfer",action:"adjust_stock",name:"Adjust Stock"}, 
                            ]
                        }
                    },
                    
                    { 
                        icon:"$money-check-dollar",
                        action:"add_new_customer", 
                        name:"Expenses", 
                        color:"orange", 
                        menu:{
                            name:"Manage Expense",
                            items:[
                                {icon:"$invoice-dollar",action:"record_expense",name:"Record Expense"},
                                {icon:"$money-check-dollar",action:"current_expense",name:"Current Expense"},
                                {icon:"$money-check-dollar",action:"manage_expense",name:"Manage Expense"}, 
                            ]
                        }
                    },
                    { 
                        icon:"mdi-text-box-multiple-outline",
                        action:"add_new_customer", 
                        name:"Quotations", 
                        color:"brown", 
                        menu:{
                            name:"Manage Quotation",
                            items:[
                                {icon:"mdi-text-box-search-outline",action:"find_quotation",name:"Find Quotation"},
                                {icon:"mdi-text-box-multiple-outline",action:"issued_quotations",name:"Issued Quotations"},
                                {icon:"mdi-text-box-check",action:"manage_quotations",name:"Manage Quotations"}, 
                            ]
                        }
                    },


                    { 
                        icon:"mdi-account",
                        action:"add_new_customer", 
                        name:"Customers", 
                        color:"", 
                        menu:{
                            name:"Customers",
                            items:[
                                {icon:"mdi-account-plus",action:"add_new_customer",name:"Add New Customer"},
                                {icon:"mdi-account",action:"manage_customers",name:"Manage Customers"}, 
                            ]
                        }
                    }, 
                    { 
                        icon:"mdi-tag",
                        action:"add_new_customer", 
                        name:"Items", 
                        color:"", 
                        menu:{
                            name:"Items",
                            items:[
                                {icon:"mdi-tag-plus",action:"add_new_item",name:"Add New Items"}, 
                                {icon:"mdi-tag",action:"manage_items",name:"Manage Items"},  
                            ]
                        }
                    }, 
                    { 
                        icon:"mdi-group",
                        action:"add_item_kit", 
                        name:"Item Kit", 
                        color:"", 
                        menu:{
                            name:"Item Kit",
                            items:[ 
                                {icon:"mdi-plus-box-outline",action:"add_new_item_kit",name:"Add New Kit/Service"},  
                                {icon:"mdi-group",action:"manage_item_kit",name:"Manage Kit/Services"}, 
                            ]
                        }
                    }, 
                    { 
                        icon:"$printer-pos-pause",
                        action:"close_register", 
                        name:"Close Register",
                        color:"secondary", 
                        type:"sales"
                    }, 
                    {
                        icon:"$printer-pos-plus",
                        action:"start_day", 
                        name:"Start Day",
                        color:"secondary",
                    },
                    {
                        icon:"mdi-order-bool-ascending-variant",
                        action:"manage_shift", 
                        name:"Manage Shift",
                        color:"secondary",
                    },
                    {
                        icon:"$printer-pos-alert" ,
                        action:"x_read", 
                        name:"X Read",
                        color:"secondary",
                        type:"day_shift"
                    },
                    
                    {
                        icon:"$printer-pos-remove",
                        action:"z_read", 
                        name:"Z Read",
                        color:"secondary",
                        type:"day_shift"
                    },
                    { 
                        icon:"mdi-cash-clock",
                        action:"cashup", 
                        name:"Cashup", 
                        color:"", 
                        type:"sales"
                    }, 
                    { 
                        icon:"mdi-sun-clock",
                        action:"days_shifts", 
                        name:"Days Shifts", 
                        color:"", 
                    }, 
                ]
            },
            ActionItems(){ 
                let actions = this.AllActionItems
                let printer = this.AssignedPrinter(null) 
                let isPrinter = printer?true:false
                if(!actions){return null}
                let newActions = actions.filter(item=>{
                    // if (isPrinter) {
                    //     return !item.no_fiscal_printer
                    // }
                    return true
                })
                return newActions
            },
            AssignedPrinter(){
                let till = this.CurrentTill 
                let old_printer = till?till.printer:null
                let assigned_printers = this.MBS.actions.JOIN_PRINTERS(till?till.assigned_printers:null) 
                return (payload)=>{ 
                    const  legal  = payload?.legal
                    const  drawer  = payload?.drawer
                    const  document  = payload?.document 
                    if(!assigned_printers){return old_printer}
                    let printers = [...assigned_printers]
                    const doc_type = document?.doc_type
                    const order = document?.order
                    const departments = order?.joined_items_departments

                    printers.sort(this.MBS.actions.dynamicSort("printer_priority",true))  
                    

                    if (this.MBS.actions.SIZE(departments)) {
                        printers=printers.filter(item=>{
                            if (!this.MBS.actions.SIZE(item.department_codes)||item.department_codes.indexOf('all')!=-1) {
                                return true
                            }
                            const index = departments.findIndex(depart=>item.department_codes.indexOf(depart.code)!=-1)
                            return index==-1?false:true
                        }) 
                        console.log(printers,"printers-dep-------");
                    }
 
                    
                    if (legal) {
                        printers = printers.filter(printer=>
                            printer.printer_option=='print_legal_receipt'||
                            printer.printer_option=='print_all'
                        ) 
                        console.log('111-----------------');
                        
                    }else { 
                        if (doc_type=="bill") {
                            printers = printers.filter(printer=>
                                printer.printer_option=='print_bill'|| 
                                printer.printer_option=='print_nonlegal_receipt'||
                                printer.printer_option=='print_all' 
                            )  
                            // printers.sort(this.MBS.actions.dynamicSort("printer_option",true)) 
                            console.log('222-----------------');
                        } else if (doc_type=="docket") {
                            printers = printers.filter(printer=>
                                printer.printer_option=='print_docket'|| 
                                printer.printer_option=='print_nonlegal_receipt'||
                                printer.printer_option=='print_all' 
                            )  
                            // printers.sort(this.MBS.actions.dynamicSort("printer_option",false)) 
                            console.log('333-----------------');
                        } else {
                            printers = printers.filter(printer=>printer.printer_option!='print_legal_receipt' )  
                        }
                    }  
                    if (drawer==true) {
                        printers = printers.filter(printer=>printer.connect_cash_drawer) 
                        console.log('5555-----------------');
                    } 
                    return printers[0]
                }
            },
            AllowChangingDepartments(){
                const till = this.CurrentTill
                const change = till?till.allow_Cashier_to_change_department:false 
                return change 
            },
            ActionTypesDisabled(){   
                let localCashup = this.LocalCashup
                if (localCashup) {
                    return null
                }
                return  ["sales",]
            }, 
 
        },
        methods:{ 
            async ITEM_ACTION(action,item,option){
                try {    
                    const isMenu = option?option.menu:false 
                    const hasMenu = item?item.menu:false  
                    const CurrentOutlet = this.CurrentOutlet
                    const selected_order = this.item_order  
                    console.log(action,item,option,'------------');

                    //----------------close if mobile
                    if(this.vs.smAndDown){ 
                        if(action == "click_mode"){
    
                        }else{
                            this.MBS.events.$emit('ON_ITEM_ACTION')
                        }
                    }
                     

                    //-------------check if menu---------------
                    if (isMenu && hasMenu) {
                        this.SELECTED_ACTION_MENU=item
                        this.dialog_action_menu=true
                        return
                    }
                    

                    //-------------actions--------------------------
                    if (action == "start_day") {
                        let link = "/sale/start-day/"
                        const path = this.MBS.actions.COMPANY_LINK(link,true) 
                        this.MBS.actions.go(path) 
                    }
                    else{
                        this.$emit("on_item_action",action,item,option)
                    }
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ITEM_ACTION',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            
            INITIALIZE_ITEMS_CATEGORIES(){
                try { 
                    const categories = this.FilteredItemCategories
                    const first_category = categories?categories[0]:null
                     if (first_category) {
                        this.SELECTED_ITEM_CATEGORY = first_category 
                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'INITIALIZE_ITEMS_CATEGORIES',
                        page:PAGE_NAME, 
                    }) 
                }
                
            },
            INITIALIZE_ITEMS_DEPARTMENTS(){
                try { 
                    const till =  this.CurrentTill 
                    const selected_department_codes = till?till.selected_department_codes:null
                    if(selected_department_codes){
                        this.selected_departments = [...selected_department_codes]
                    }else{} 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'INITIALIZE_ITEMS_DEPARTMENTS',
                        page:PAGE_NAME, 
                    }) 
                }
                
            },
            UPDATE_CLICK_MODE(value){ 
                try {
                    this.MBS.events.$emit("UPDATE_CLICK_MODE",value)  
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'UPDATE_CLICK_MODE',
                        page:PAGE_NAME, 
                    }) 
                }
            },



            async ADD_ITEM(item_key, item_code){
                try { 
                    this.$emit("on_add_item",item_key, item_code)
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ADD_ITEM',
                        page:PAGE_NAME, 
                    }) 
                }
            },
            REMOVE_DEPARTMENT (item) { 
                const index = this.selected_departments.indexOf(item.code)
                if (index >= 0) this.selected_departments.splice(index, 1)
            },

            //---------------[MAIN FUNCTIONS]------------   
             

        },
        beforeDestroy(){
            try {
                this.MBS.events.$off('ON_QR_SCAN', this.ON_QR_SCAN);  
                this.MBS.events.$off('MBS_KEYBOARD', this.MBS_KEYBOARD);      
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'beforeDestroy',
                    page:PAGE_NAME, 
                })
            }
        },
        watch:{   
            CompanySettings(value){
                if (value) {   
                    this.INITIALIZE_ITEMS_CATEGORIES()
                    this.INITIALIZE_ITEMS_DEPARTMENTS()
                }
            }, 
            selected_departments(value){
                this.ON_UPDATE_DEPARTMENT(value)
                if (value) {   
                    this.INITIALIZE_ITEMS_CATEGORIES() 
                }
            },  
        } 

    }
</script>
<style>
    .selected {
        background-color: #a8dadc;
    }
    .checked {
        background-color: #dadada;
    }
    
</style> 